// extracted by mini-css-extract-plugin
export var link = "Link-module--link--0ae32";